import React, { useEffect, useState } from 'react';
import { format, startOfDay, endOfDay } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import Loader from '../../atoms/icons/loader';

import './feed-counter-dashboard.m.css';

export const FeedCounterDashboard = props => {
  const maxValue = format(new Date(), 'mm-dd-yyyy');
  const [data, setData] = useState({});
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(new Date().toDateString());
  const [endDate, setEndDate] = useState(new Date().toDateString());
  const [changer, setChanger] = useState(1);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response = await (
          await fetch(`/feed/count?published-after=${startDate}&published-before=${endDate}`)
        ).json();
        if (response) {
          const formatTime = date => {
            return new Date(
              formatInTimeZone(new Date(date), 'Asia/Kolkata', 'dd MMMM yyyy, h:mm aa')
            );
          };
          const publishedAfter = Number(Date.parse(startOfDay(formatTime(startDate))));
          const publishedBefore = Number(Date.parse(endOfDay(formatTime(endDate))));

          const filteredItems = {};
          let totalCount = 0;
          response.items.forEach(item => {
            const firstPublishedAt = Number(item['first-published-at']);
            const section = item?.metadata?.['story-attributes']?.syndicatedfrom?.[0];
            if (
              section &&
              firstPublishedAt >= publishedAfter &&
              firstPublishedAt <= publishedBefore
            ) {
              if (filteredItems[section]) {
                filteredItems[section] += 1;
              } else {
                filteredItems[section] = 1;
              }
              totalCount += 1;
            }
          });
          setData(filteredItems);
          setTotal(totalCount);
        }
        setLoading(false);
      } catch (error) {
        console.error('error :>>>>>', error);
        setLoading(false);
      }
    })();
  }, [changer]);

  const onStartDate = e => {
    if (e && e.target) {
      setStartDate(e.target.value);
    }
  };

  const onEndDate = e => {
    if (e && e.target) {
      setEndDate(e.target.value);
    }
  };

  const onGetFeedCount = () => {
    setChanger(changer + 1);
  };

  return (
    <div className="container" styleName="feed-counter-container">
      <h1>Feed Counter Dashboard</h1>
      <div styleName="date-fields-wrapper">
        <div>
          <label htmlFor="start-date">Published After:</label>
          <input
            type="date"
            id="start-date"
            name="start-date"
            defaultValue={startDate}
            onChange={onStartDate}
            max={maxValue}
          />
        </div>
        <div>
          <label htmlFor="end-date">Published Before:</label>
          <input
            type="date"
            id="end-date"
            name="end-date"
            defaultValue={endDate}
            onChange={onEndDate}
            max={maxValue}
          />
        </div>
        <button onClick={onGetFeedCount}>Get Feed Count</button>
      </div>
      {loading ? (
        <div>
          <Loader color={`var(--first-color)`} />
        </div>
      ) : (
        <div>
          <table>
            <thead>
              <tr>
                <th>Section</th>
                <th>Count</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(data).map((key, index) => (
                <tr key={index}>
                  <td>{key}</td>
                  <td>{data[key]}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <h4>
            Total Feed Count: <span>{total}</span>
          </h4>
        </div>
      )}
    </div>
  );
};
